import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(descriptionStyles, {
    wrapper: {
        css: css`
            margin-top: 30px;
            margin-bottom: 20px;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
        `,
    },
});
